import SalesGrid from "./SalesGrid";

/**
 * Renders the "Sales Gain" page
 * @returns {JSX.Element}
 * @constructor
 */
const GainsPage = () => {
    return (
        <div>
            <SalesGrid />
        </div>
    );
}

export default GainsPage;
